import * as React from "react";

interface ICheckProps {
    label: string;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: boolean;
    onChange?: (value: boolean) => void;
}

export default class CheckCtl extends React.PureComponent<ICheckProps> {

    onCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange?.(e.currentTarget.checked);

    render() {
        return <label className={(this.props.disabled ? "disabled " : "") + this.props.className}>
                    <input type="checkbox"
                        value={true.toString()}
                        checked={this.props.value ?? false}
                        placeholder={this.props.placeholder}
                        onChange={this.onCheckChange}
                        disabled={this.props.disabled}/>
                    <span>{this.props.label}</span>
               </label>;
    }
}